import React from 'react';
import styled from 'styled-components';
import { ButtonProps } from './button';
import { sizes } from '../../theme/sizes';

interface Props {
  active: boolean;
  size?: ButtonProps['size'] | string;
}

const getSize = (size?: ButtonProps['size'] | string) => {
  return sizes[size ?? 'md'] ?? size;
};

const Track = styled.div<{ active: boolean; size?: ButtonProps['size'] | string }>`
  width: calc(${({ size }) => getSize(size)} * 2 + 4px);
  height: calc(${({ size }) => getSize(size)} + 4px);
  border-radius: 9999px;
  background-color: ${({ active }) => (active ? '#007AFF' : '#C8C8CA')};
  position: relative;
  flex-shrink: 0;
  transition: background-color 200ms ease;
`;

const Thumb = styled.div<{ active: boolean; size?: ButtonProps['size'] | string }>`
  position: absolute;
  top: 2px;
  left: 2px;
  width: ${({ size }) => getSize(size)};
  height: ${({ size }) => getSize(size)};
  border-radius: 50%;
  background: #ffffff;
  box-shadow:
    0 3px 8px rgba(0, 0, 0, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.16);
  transform: ${({ active, size }) => (active ? `translateX(${getSize(size)})` : 'translateX(0)')};
  transition: transform 200ms ease;
`;

export const ToggleSwitch = (props: Props) => {
  const { active, size } = props;

  return (
    <Track active={active} size={size}>
      <Thumb active={active} size={size} />
    </Track>
  );
};
